'use client';

import { Group, Text, Flex } from '@mantine/core';
import { IconBrandInstagram, IconBrandDiscordFilled, IconMug, IconSectionSign, IconBrandTwitch } from '@tabler/icons-react';
import Image from 'next/image';
import Link from 'next/link';

import NarilahLogo from '../../assets/logo-white.svg';
import { FooterLink } from './FooterLink';
import classes from './Footer.module.css';

export function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <Flex className={classes.footer} direction="row" align="center" justify="center">
            <Link className={classes.logo} href="/">
                <Image width={110} src={NarilahLogo} alt="Narilah Logo" />
            </Link>
            <Text className={classes.text}>&copy; {currentYear} <Link href="https://narilah.de" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '6px' }}>Narilah</Link></Text>
            <Group gap={0} justify="flex-end" wrap="nowrap" style={{ flex: '1' }}>
                {/*<FooterLink link="https://linktr.ee/waswird.podcast"><IconBrandApplePodcast /></FooterLink>*/}
                <FooterLink link="https://www.twitch.tv/narilah/"><IconBrandTwitch /></FooterLink>
                <FooterLink link="https://www.instagram.com/ichbins.narilah/"><IconBrandInstagram /></FooterLink>
                <FooterLink link="https://discord.com/invite/RWjQrY72yU"><IconBrandDiscordFilled /></FooterLink>
                <FooterLink link="https://ko-fi.com/narilah"><IconMug /></FooterLink>
                <FooterLink link="/impressum" target="_self"><IconSectionSign /></FooterLink>
            </Group>
        </Flex>
    );
}
